import { ActionContext } from 'vuex';
import { GeneralHelper } from '../../helper/general';

const helper = new GeneralHelper();

export default {
	namespaced: true,
	state: {
		notifications: [],
		activeNotifications: [],
		pastNotifications: [],
		default_timeout: 5,
		is_suppressing: false,
		base_notification: {
			id: false,
			type: 'notice',
			message: '',
			timeout: false,
			repeated: 0,
			presence: 'passive',
		},
	},
	mutations: {
		ADD_NOTIFICATION: (state: any, notification: any, isActive = false) => {
			if (state.is_suppressing) return;

			// Create a new notification object and merge the user notification.
			const baseNotification = helper.deepClone(state.base_notification);
			const newNotification = Object.assign(baseNotification, notification);
			newNotification.id = new Date().valueOf();

			// Create a built in timeout.
			if (!isActive) {
				newNotification.timeout = setTimeout((state: any, id: number) => {

					// Get the notification item.
					const index = helper.findObjectByProperty(state.notifications, 'id', id);
					const currentNotification = state.notifications.splice(index, 1)[0];

					// See if there is a message that already exists.
					const nMessages: Array<string> = state.pastNotifications.map((n: any) => n.message);
					const nMessageIndex = nMessages.indexOf(currentNotification.message);

					// Check for existing.
					if (nMessageIndex === -1) {
						state.pastNotifications.unshift(currentNotification);
					} else {
						const repetition = (currentNotification.repeated + 1);
						state.pastNotifications[nMessageIndex].repeated += repetition;
					}
				}, (state.default_timeout * 1000), state, newNotification.id);
			}

			// Add new notification.
			state.notifications.push(newNotification);
		},

		REMOVE_NOTIFICATION: (state: any, notification_id: number) => {
			const notificationIndex = helper.findObjectByProperty(state.notifications, 'id', notification_id);
			clearTimeout(state.notifications[notificationIndex].timeout);
			state.notifications.splice(notificationIndex, 1);
		},

		CLEAR_NOTIFICATIONS: (state: any) => {
			state.pastNotifications = [];
		},

		SET_ACTIVE_NOTIFICATIONS: (state: any, notifications: Array<any>) => {
			state.activeNotifications = notifications;
		},

		SET_SUPPRESSION: (state: any, status: boolean) => {
			state.is_suppressing = status;
		},
	},
	actions: {
		add: (context: ActionContext<any, any>, notification: any) => {
			if (context.state.is_suppressing) return;
			const nMessages: Array<string> = context.state.notifications.map((n: any) => n.message);
			const nMessageIndex = nMessages.indexOf(notification.message);
			if (nMessageIndex > -1) {
				context.state.notifications[nMessageIndex].repeated++;
				return;
			}
			context.commit('ADD_NOTIFICATION', notification);
		},

		remove: (context: ActionContext<any, any>, notification_id: number) => {
			context.commit('REMOVE_NOTIFICATION', notification_id);
		},

		clear: (context: ActionContext<any, any>) => {
			context.commit('CLEAR_NOTIFICATIONS');
		},

		setActive: (context: ActionContext<any, any>, notifications: Array<any>): void => {
			context.commit('SET_ACTIVE_NOTIFICATIONS', notifications);
		},

		suppress: (context: ActionContext<any, any>, seconds: number): void => {
			context.commit('SET_SUPPRESSION', true);
			setTimeout(() => {
				context.commit('SET_SUPPRESSION', false);
			}, 1000 * seconds);
		},
	},
};
